import React, { Fragment, useState } from "react";
import { Box, Container, Grid, Button } from "@mui/material";
import PageHeader from "../../example/pages-header/PageHeader";
import useFetchObjects from "../../api/useFetchObjects";
import ProgramsSkeleton from "./loading/ProgramsSkeleton";
import ErrorPage from "../../components/error/Error";
import NoData from "../../components/no-data/NoData";
import ProgramCard from "../../example/program/ProgramCard";
import SEO from "../../components/ceo/CEO";

const Programs = () => {
  const { data, isLoading, isError, isSuccess, error, refetch } =
    useFetchObjects(["Programs"], "programs");

  const [filter, setFilter] = useState("All");

  const filteredPrograms = data?.filter((program) =>
    filter === "All" ? true : program.program_type_display === filter,
  );

  const handleFilter = (type) => {
    setFilter(type);
  };

  if (isLoading) {
    return <ProgramsSkeleton />;
  }

  if (isError) {
    return <ErrorPage errorMessage={error.message} refetch={refetch} />;
  }

  if (isSuccess && (!data || data.length === 0)) {
    return <NoData refetch={refetch} />;
  }

  if (isSuccess) {
    return (
      <Fragment>
        <SEO
          title="Our Programs"
          description="Explore our upcoming events, past achievements, and special projects at SHALL Social and Development Organization."
          url="https://shallafg.org/programs/"
          image="https://shallafg.org/media/images/logo.png"
        />
        <PageHeader
          title="Our Programs"
          subtitle="Explore our upcoming events, past achievements, and special projects."
        />

        <Box
          sx={{
            backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
            color: "#FFFFFF",
            paddingY: "100px",
            minHeight: "100vh",
          }}
        >
          <Container maxWidth="lg">
            {/* Professional Filter Section */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: { xs: "wrap", md: "nowrap" },
                gap: { xs: "15px", md: "25px" },
                mb: "40px",
              }}
            >
              <Button
                variant={filter === "All" ? "contained" : "text"}
                onClick={() => handleFilter("All")}
                sx={{
                  color: filter === "All" ? "#FFFFFF" : "#A9C9EA",
                  backgroundColor: filter === "All" ? "#007BFF" : "transparent",
                  fontWeight: 600,
                  fontSize: { xs: "0.9rem", md: "1rem" },
                  borderRadius: "30px",
                  padding: { xs: "8px 24px", md: "12px 36px" },
                  textTransform: "uppercase",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#0056b3",
                    color: "#FFFFFF",
                  },
                }}
              >
                All
              </Button>

              <Button
                variant={filter === "Upcoming" ? "contained" : "text"}
                onClick={() => handleFilter("Upcoming")}
                sx={{
                  color: filter === "Upcoming" ? "#FFFFFF" : "#A9C9EA",
                  backgroundColor:
                    filter === "Upcoming" ? "#007BFF" : "transparent",
                  fontWeight: 600,
                  fontSize: { xs: "0.9rem", md: "1rem" },
                  borderRadius: "30px",
                  padding: { xs: "8px 24px", md: "12px 36px" },
                  textTransform: "uppercase",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#0056b3",
                    color: "#FFFFFF",
                  },
                }}
              >
                Upcoming
              </Button>

              <Button
                variant={filter === "Past" ? "contained" : "text"}
                onClick={() => handleFilter("Past")}
                sx={{
                  color: filter === "Past" ? "#FFFFFF" : "#A9C9EA",
                  backgroundColor:
                    filter === "Past" ? "#007BFF" : "transparent",
                  fontWeight: 600,
                  fontSize: { xs: "0.9rem", md: "1rem" },
                  borderRadius: "30px",
                  padding: { xs: "8px 24px", md: "12px 36px" },
                  textTransform: "uppercase",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#0056b3",
                    color: "#FFFFFF",
                  },
                }}
              >
                Past
              </Button>

              <Button
                variant={filter === "Special" ? "contained" : "text"}
                onClick={() => handleFilter("Special")}
                sx={{
                  color: filter === "Special" ? "#FFFFFF" : "#A9C9EA",
                  backgroundColor:
                    filter === "Special" ? "#007BFF" : "transparent",
                  fontWeight: 600,
                  fontSize: { xs: "0.9rem", md: "1rem" },
                  borderRadius: "30px",
                  padding: { xs: "8px 24px", md: "12px 36px" },
                  textTransform: "uppercase",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#0056b3",
                    color: "#FFFFFF",
                  },
                }}
              >
                Special Projects
              </Button>
            </Box>

            {/* Programs Grid */}
            <Grid container spacing={6}>
              {filteredPrograms.map((program) => (
                <Grid item xs={12} sm={6} md={4} key={program.id}>
                  <ProgramCard program={program} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      </Fragment>
    );
  }

  return null;
};

export default Programs;
